import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import "common/translations";
import { RootState } from "../../redux/store";
import "./AppContent.less";
import { LoadingSpinner } from "components/common";
import { NetworkSynchronization } from "common/hocs/NetworkSynchronization";
import BadgeHelper from "../../common/network/helpers/badges/BadgeHelper";
import { AppRouterContent } from "./content/AppRouterContent";
import AuthHelper from "../../common/auth/helpers/AuthHelper";
import Routers from "../../Routers";
import { useLocation, useNavigate } from "react-router-dom";
import { ConnectionChecker } from "../../common/hocs/ConnectionChecker";
import { LogSynchronization } from "../../common/hocs/LogSynchronization";
import SettingsSelectPage from "../eventSelectPage/SettingsSelectPage";
import { APPLICATION } from "../eventSelectPage/constants/common";
import ApplicationsSelect from "../eventSelectPage/applicationsSelect/ApplicationsSelect";
import EventSelectBox from "../eventSelectPage/eventSelectBox/EventSelectBox";
import { Routes } from "../../routes";
import { IdleChecker } from "../idleCheck/IdleChecker";
import { badgesSelector } from "redux/eventEdition/selectors/eventEdition.selectors";
import { useInitialAppSetup } from "./hooks/useInitialAppSetup/useInitialAppSetup";
import { filterEventsByEndDate } from "../eventSelectPage/utils";
import { useClearScannedBadges } from "./hooks/useClearScannedBadges/useClearScannedBadges";

const AppContent = () => {
  const [shouldDisplayApplications, setDisplayApplications] = useState(true);
  const reduxState = useSelector((state: RootState) => state);
  const isAdmin = reduxState.metadata.isAdmin;
  const eventEdition = reduxState.eventEdition?.eventEdition;
  const reduxBadges = useSelector(badgesSelector);
  const { storageEventEditionId, eventEditionConfiguration, isDataFetching } = useInitialAppSetup();
  const { fetchCounties, fetchEventEdition, error, options, getMercuryShows, loading: eventLoading } = eventEditionConfiguration;
  const { clearFreyaScannedBadgesPeriodically, stopClearingScannedBadges } = useClearScannedBadges();

  useEffect(() => {
    if (reduxBadges?.length) {
      BadgeHelper.setBadgesWithoutFilter(reduxBadges);
    }
  }, [reduxBadges]);

  useEffect(() => {
    if (AuthHelper.isFreya()) {
      clearFreyaScannedBadgesPeriodically();
    }
    return () => stopClearingScannedBadges();
  }, []);

  const location = useLocation();
  const history = useNavigate();

  const applicationSelectionHandler = value => {
    if (value === APPLICATION.FREYA) {
      history(Routes.freya);
    } else if (value === APPLICATION.ODIN) {
      history(Routes.homepage);
    }
    window.location.reload();

    setDisplayApplications(false);
  };

  const isMainPage = location.pathname === Routes.main;
  const shouldShowAppSelection = isMainPage && shouldDisplayApplications;
  const shouldDisplayEventSelect = !eventEdition && !storageEventEditionId && !location.pathname.includes(Routes.freya);

  if (shouldShowAppSelection) {
    return (
      <SettingsSelectPage>
        <ApplicationsSelect onClick={applicationSelectionHandler} />
      </SettingsSelectPage>
    );
  }

  if (shouldDisplayEventSelect) {
    return (
      <SettingsSelectPage>
        <EventSelectBox
          isLoading={eventLoading}
          isError={Boolean(error)}
          fetchEventEdition={fetchEventEdition}
          fetchCounties={fetchCounties}
          options={filterEventsByEndDate(options)}
          getMercuryShows={getMercuryShows}
        />
      </SettingsSelectPage>
    );
  }

  if (AuthHelper.isWithoutAuth()) {
    return (
      <ConnectionChecker>
        <LogSynchronization>
          <Routers />
        </LogSynchronization>
      </ConnectionChecker>
    );
  }

  return (
    <ConnectionChecker>
      <LogSynchronization>
        <IdleChecker />
        <NetworkSynchronization>{isDataFetching ? <LoadingSpinner /> : <AppRouterContent isAdmin={isAdmin} />}</NetworkSynchronization>
      </LogSynchronization>
    </ConnectionChecker>
  );
};

export default AppContent;
export { AppContent };
